import type { CategoryNavConfig, CategoryNavItem } from '@/lib/sections/types';
import { CmsSchema, useCmsFields } from '@/cms/content';
import './category-nav.css';

function CategoryTile({ item, index }: { item: CategoryNavItem; index: number }) {
  // New, category-based keys keep saved content from the former seven cards
  // from replacing the new photos or assigning an old label to a different link.
  const prefix = `home.categoryPhotos.${item.handle ?? index}`;
  const cms = useCmsFields([
    { key: `${prefix}.title`, label: 'Tytuł', section: `Kafel kategorii ${index + 1}`, kind: 'text', defaultValue: item.title, required: true },
    { key: `${prefix}.image`, label: 'Zdjęcie', section: `Kafel kategorii ${index + 1}`, kind: 'image', defaultValue: item.image, required: true },
    { key: `${prefix}.alt`, label: 'Opis zdjęcia', section: `Kafel kategorii ${index + 1}`, kind: 'alt', defaultValue: item.title },
  ]);

  return (
    <a
      href={item.href}
      aria-labelledby={`home-category-card-${index}`}
      className="home-category-tile"
    >
      <CmsSchema fields={cms.fields} />
      <img
        {...cms.image(`${prefix}.image`)}
        {...cms.alt(`${prefix}.alt`)}
        src={cms.value(`${prefix}.image`)}
        alt={cms.value(`${prefix}.alt`)}
        className="home-category-tile__image"
        width={163}
        height={231}
        loading="lazy"
        fetchPriority="low"
        decoding="async"
      />
      <div className="home-category-tile__panel">
        <span
          id={`home-category-card-${index}`}
          {...cms.text(`${prefix}.title`)}
          className="home-category-tile__title"
        >
          {cms.value(`${prefix}.title`)}
        </span>
      </div>
    </a>
  );
}

export function CategoryNav({ config }: { config: CategoryNavConfig }) {
  return (
    <section aria-label="Kategorie produktów" className="home-category-nav">
      <div className="home-category-nav__grid">
        {config.categories.map((item, index) => (
          <CategoryTile key={item.handle ?? item.title} item={item} index={index} />
        ))}
      </div>
    </section>
  );
}
